import { orchestrator } from 'satcheljs';
import { refreshUpNextCalendarEventAction } from '../actions/internalActions';
import { getScenarioActions } from '../actions/getScenarioActions';
import {
    getAgendaLockedCalendarEventsReader,
    getLockedCalendarEventsStore,
} from '../selectors/calendarEventsLockedStoreSelectors';
import { getScenarioSelectors } from '../selectors/agendaStoreSelectors';

orchestrator(refreshUpNextCalendarEventAction, async actionMessage => {
    refreshUpNextCalendarEvent(actionMessage.folderIds, actionMessage.scenarioId);
});

export async function refreshUpNextCalendarEvent(
    folderIds: string[],
    scenarioId: string
): Promise<null> {
    const { upNextCalendarEvent, getEventLockCacheId } = getScenarioSelectors(scenarioId);
    const { setUpNextCalendarEventInStore } = getScenarioActions(scenarioId);
    const lockId = getEventLockCacheId();
    const { fetchFullCalendarEvent } = getLockedCalendarEventsStore(lockId);
    const { getUpNextEvent } = getAgendaLockedCalendarEventsReader(lockId);

    const refreshedUpNextEvent = getUpNextEvent(folderIds);

    if (refreshedUpNextEvent && upNextCalendarEvent().id !== refreshedUpNextEvent.event.ItemId.Id) {
        // if the up next has changed, fetch full calendar event and store it in the events cache
        fetchFullCalendarEvent(
            refreshedUpNextEvent.event.ItemId,
            refreshedUpNextEvent.event.ParentFolderId.Id
        );
    }

    const upNextEventActionMessage = refreshedUpNextEvent
        ? { id: refreshedUpNextEvent.event.ItemId.Id, index: refreshedUpNextEvent.index }
        : { id: null, index: null };
    if (
        upNextCalendarEvent().id !== upNextEventActionMessage.id ||
        upNextCalendarEvent().index !== upNextEventActionMessage.index
    ) {
        /** set the up next calendar in the store only if it has changed
         * to avoid unecessary component rerenders */
        setUpNextCalendarEventInStore(upNextEventActionMessage);
    }
    return null;
}
